import {html} from 'lit-html';
import styles from './Footer.css';

export default ({notice, year}) => html`
    <div class="${styles.footer}">
        <div class="${styles.notice}">${notice} &copy; ${year}</div>
    </div>
`;
